var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;opacity:0.8;}")),React.createElement("polygon",{"className":"cls-1","points":"31.38 4.95 26.43 0 15.69 10.74 4.95 0 0 4.95 10.74 15.69 0 26.43 4.95 31.38 15.69 20.64 26.43 31.38 31.38 26.43 20.64 15.69 31.38 4.95","key":1})]);
}

Close.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 31.38 31.38"};

module.exports = Close;

Close.default = Close;
